/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();



// Check and hide newsletter signup for discount code

(function(){
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  const discountCode = getCookie('discount_code');

  if (discountCode) {
    const newsletterSectionFooter = document.querySelector('.footer__newsletter.layout-stack');
    const newsletterSectionMain = document.querySelector('.newsletter-section');
    if (newsletterSectionFooter) newsletterSectionFooter.style.display = 'none';
    if(newsletterSectionMain) newsletterSectionMain.style.display = 'none';
  }
})();





// Smooth scroll on same page + redirect correctly from other pages
// Put this in a global script (theme.liquid / header snippet)
// Handles: same-page clicks, cross-page clicks, and landing with hash

(function () {
  const STORAGE_KEY = 'shopByLineTarget';

  // compute offset dynamically (fallback to 120)
  function getHeaderOffset() {
    try {
      const header = document.querySelector('header') || document.querySelector('.site-header') || document.querySelector('.header');
      return (header && header.offsetHeight) ? header.offsetHeight : 120;
    } catch (e) {
      return 120;
    }
  }

  function scrollWithOffset(selector, smooth = true) {
    if (!selector) return;
    const target = document.querySelector(selector);
    if (!target) return;

    const offset = getHeaderOffset();
    const elementPosition = target.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: smooth ? 'smooth' : 'auto'
    });
  }

  // Click handler for links
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a.shop-by-line');
    if (!link) return;

    const targetSelector = link.getAttribute('href');
    if (!targetSelector || !targetSelector.startsWith('#')) return;

    e.preventDefault();

    const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

    // If on home ("/" or empty), just scroll
    if (currentPath === '/' || currentPath === '/index' || currentPath === '') {
      scrollWithOffset(targetSelector, true);
      return;
    }

    // Otherwise store the target and go to homepage WITHOUT hash
    try {
      sessionStorage.setItem(STORAGE_KEY, targetSelector);
    } catch (err) {
      // ignore storage errors
    }
    // navigate to homepage (no hash) so browser doesn't perform an immediate anchor jump
    window.location.href = '/';
  });

  // Homepage auto-scroll logic
  document.addEventListener('DOMContentLoaded', function () {
    // prevent browser's automatic restoration interfering (if supported)
    if ('scrollRestoration' in history) {
      try { history.scrollRestoration = 'manual'; } catch (e) {}
    }

    // Delay a little so header images/fonts/Shopify blocks load and header height is final
    const tryScroll = () => {
      // 1) stored from other pages
      let stored = null;
      try { stored = sessionStorage.getItem(STORAGE_KEY); } catch (e) { stored = null; }

      if (stored) {
        scrollWithOffset(stored, true);
        try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
        // If a hash exists in URL also, remove it to avoid default jumps later
        if (window.location.hash) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        return;
      }

      // 2) fallback when user landed directly on /#section or bookmarked link
      const hash = window.location.hash;
      if (hash) {
        scrollWithOffset(hash, true);
        // remove hash after scrolling to keep URL clean / avoid re-jump
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    };

    // a small timeout helps in case heavy blocks load or header resizes
    setTimeout(tryScroll, 50);
    // also try again a little later to be robust
    setTimeout(tryScroll, 300);
  });
})();



